import { useCallback } from 'react';

import { usePatchViewerNotificationSubscriptionsMutation } from 'src/hooks/__generated__/queries';
import { NotificationSubscriptionStatus, NotificationSubscriptionSubject } from 'src/types/__generated__/graphql';

export const useEnableAdSearchEmailNotification = () => {
    const [patchViewerNotificationSubscriptions] = usePatchViewerNotificationSubscriptionsMutation();

    const enableAdSearchEmailNotification = useCallback(async () => {
        await patchViewerNotificationSubscriptions({
            variables: {
                subscriptions: [
                    {
                        subject: NotificationSubscriptionSubject.AdSearchResultsEmail,
                        status: NotificationSubscriptionStatus.Active,
                    },
                ],
            },
            awaitRefetchQueries: true,
            refetchQueries: ['CurrentUser'],
        });
    }, [patchViewerNotificationSubscriptions]);

    return {
        enableAdSearchEmailNotification,
    };
};
